<template>
  <div class="settings">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_element header_icone mobile">
          <!--          <span class="icon icon-left-arrow icon-lg"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>
        </router-link>
        <h1 class="header_element">Paramètres</h1>
      </div>
    </div>
    <div class="content">
      <div class="content_section">
        <img class="content_img profile-user-img" :src="user.avatar" alt="">
        <p class="content_success">{{ user.score }}</p>
      </div>
      <div class="content_section">

        <span :class="form.response.type" v-if="form.response">{{ form.response.msg }}</span>

        <form v-on:submit.prevent="submitForm" class="form-user desktop">

          <div class="form_field">
            <input type="text" v-model="form.username">
          </div>
          <div class="form_field">
            <input type="email" v-model="form.email">
          </div>
          <div class="form_field">
            <input type="password" v-model="form.password" placeholder="mot de passe">
          </div>
          <span class="error_form" v-show="form.error.mdpconf">{{ form.error.mdpconf }}</span>
          <div class="form_field" v-if="form.password !== ''" :class="{'error_input':form.error.mdpconf!==''}">
            <input type="password" v-model="form.confirmPassword" placeholder="confirmation mot de passe">
          </div>

          <button class="btn btn-primary">Modifier</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import {store} from '../store/store';
import {mapActions, mapState} from "vuex";

export default {
  name: 'Settings',
  data() {
    return {
      user: store.getters.getUser,
      form: {
        username: store.getters.getUser.name,
        email: store.getters.getUser.email,
        password: '',
        confirmPassword: '',
        error: {
          username: '',
          email: '',
          password: '',
          mdpconf: ''
        },
        response: null,
      }
    }
  },
  methods: {
    ...mapActions([
      'updateUser'
    ]),
    submitForm() {
      let {username, email, password, confirmPassword} = this.form
      if (password === confirmPassword) {

        this.updateUser(this.form)
            .then(res => {
              this.form.response = res
            })

      } else {
        this.form.error.mdpconf = 'mot de passe différent'
      }

    }
  },
  computed: {
    ...mapState([
      "masks",
      "logged"
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});

  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.settings {
  z-index: 1;
  background: #fff;
  /*margin-bottom: 40px;*/
  padding: 0 20px;
}


.header_icone {
  padding-right: 10px;
  color: white;
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}


.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_section {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}

.content_name {
  text-align: center;
  color: #00d6ff;
  font-size: 35px;
  margin: 0;
  font-family: 'Bebas Neue', cursive;
  letter-spacing: 2px;
}

.content_success {
  text-align: center;
  color: #00a6d9;
  font-size: 20px;
  margin: 0;
  font-family: Calibri;
}

.content_element {
  color: white;
  border-radius: 20px;
  background-color: #00d6ff;
  height: 70px;
  display: flex;
  width: 90%;
  margin: 10px auto;
  justify-content: space-between;
}

span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content_img {
  width: 150px;
  border-radius: 100%;
  height: auto;
  margin: auto;
  border: 2px solid var(--main-color);
}


.form-user {
  margin-top: 10px;
  display: flex !important;
  flex-direction: column;
}

.form-user .form_field {
  display: flex;
  margin: 10px 0;
  flex: 1;
}

.form-user .form_field input {
  flex: 1;
  padding: 10px;
  border: 1px solid #00d6ff;
  border-radius: 10px;
}


.btn {
  flex: 1;
  padding: 10px;
  font-family: Poppins;
  border: none;
  background: #00d6ff;
  color: #fff;
  border-radius: 10px;
  margin-top: 20px;
  transition: .5s;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: bold;
}

.btn:hover {
  cursor: pointer;
  background: #297F9E;
  color: #fff;
}

a {
  text-decoration: none;
}

a.addinsta {
  color: #00a6d9;
}


.error {
  border-radius: 10px;
  font-family: Poppins;
  padding: 5px;
  background: #ff5047;
  color: #fff;
}

.warning {
  border-radius: 10px;
  font-family: Poppins;
  padding: 5px;
  background: #ffb547;
  color: #fff;
}

.succeed {
  border-radius: 10px;
  font-family: Poppins;
  padding: 5px;
  background: #65c249;
  color: #fff;
}

.error_form {
  color: #ff5047;
  font-size: 12px;
  padding: 0px 5px;
}

.error_input input {
  border-color: #ff5047 !important;
}

@media screen and (min-width: 750px) {
  .mobile {
    display: none;
  }

  .content_section {
    width: 70%;
    margin: auto;
    margin-top: 30px;
  }
}
</style>
